export * from './lib/search-ui-text-results'

export type { CallbackTextResult, AnchorTextResult } from './lib/types'
